import { create } from "zustand";

const defaultMessage = "Your session expired. Sign in again to keep working without leaving this page.";

const initialState = {
    reauthRequired: false,
    message: defaultMessage,
    sessionBootstrapStatus: "idle",
    sessionBootstrapStep: "checkingSavedSession"
};

const useAuthSessionStore = create((set) => ({
    ...initialState,
    openReauthModal: (message = defaultMessage) => set((state) => ({
        ...state,
        reauthRequired: true,
        message
    })),
    closeReauthModal: () => set((state) => ({
        ...state,
        reauthRequired: false,
        message: defaultMessage
    })),
    startSessionBootstrap: () => set((state) => {
        if (state.sessionBootstrapStatus === "pending") {
            return state;
        }

        return {
            ...state,
            sessionBootstrapStatus: "pending",
            sessionBootstrapStep: "checkingSavedSession"
        };
    }),
    setSessionBootstrapStep: (step) => set((state) => ({
        ...state,
        sessionBootstrapStep: step
    })),
    finishSessionBootstrap: () => set((state) => ({
        ...state,
        sessionBootstrapStatus: "complete"
    })),
    resetSessionBootstrap: () => set((state) => ({
        ...state,
        sessionBootstrapStatus: "idle",
        sessionBootstrapStep: "checkingSavedSession"
    }))
}));

export default useAuthSessionStore;
